import { replace } from "react-router-redux";
import actionTypes from "../actionTypes";

export default ({ dispatch }) => next => action => {
  if (action.type === actionTypes.PERMISSION_POST) {
    dispatch(replace("/permissions"));
  } else if (action.type === actionTypes.USER_POST) {
    dispatch(replace("/users"));
  } else if (action.type === actionTypes.ROLE_POST) {
    dispatch(replace("/roles"));
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/redux/middleware/AfterFormSoftRedirects.js